import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    npiBatchId: "",
    npiDataPath: "",
    npiDescription: "",
    npiProgress: 0,
    npiTotal: 0,
    npiStatus: "Init",
    npiCreatedTs: "",
}


export const npiBatchSlice = createSlice({
    name: 'npiBatch',
    initialState,
    reducers: {
        addNpiBatch: (state, action) => {
            if (action.payload && action.payload.id) {
                const res = action.payload;
                state.npiBatchId = res.id;
                state.npiDataPath = res.dataPath;
                state.npiDescription = res.description;
                state.npiProgress = res.progress;
                state.npiTotal = res.total;
                state.npiStatus = res.status;
                state.npiCreatedTs = res.createdTs;
            }
        },
        resetNpiBatch: () => initialState,
    }
})

export const { addNpiBatch, resetNpiBatch }= npiBatchSlice.actions;

export default npiBatchSlice.reducer;